<template lang="pug">
table.ui-app-data-table
  tbody
    tr(
      v-for="(item, field) in data"
      :key="field"
    )
      td
        RouterLink(
          :to="`/api/v1/purchase_invoice_attachments/${item['id']}`"
          label="item['filename']"
          target="_blank"
        ) {{ item["filename"] }}
</template>

<script>
export default {
  props: ["data"],
};
</script>
